import { SELECT_PRODUCT, SET_EMAIL } from '../actions/constants'

const initialState = {
  productName: null,
  email: null,
  deviceType: 'spectro-cold',
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SELECT_PRODUCT:
      return {
        ...state,
        productName: action.payload,
      }
    case SET_EMAIL:
      return {
        ...state,
        email: action.payload,
      }

    default:
      return {
        ...state,
      }
  }
}
